import { IS_EYEJACK_APP } from "../utils/utils";
import OpenURLBase from "./openurl.base";
import OpenURLApp from "./openurl.app";
import OpenURLWeb from "./openurl.web";

export default class OpenURL extends OpenURLBase {
  private impl: OpenURLBase;
  
  constructor() {
    super();

    if( IS_EYEJACK_APP ) {
      this.impl = new OpenURLApp();
    } else {
      this.impl = new OpenURLWeb();
    }    
  }

  public override async open(url:string): Promise<boolean> {
    return this.impl.open(url);
  }
}

const _openURL = new OpenURL();
export async function openURL(url:string): Promise<boolean> {
  return _openURL.open(url);
}